<template>
  <div class="card-main">
    <b-container fluid>
      <!-- Modal LGPD -->
      <div>
        <b-modal id="modal-lgpd" title="Termo de Consentimento" hide-footer>
          <p v-html="empresa.lgpd_texto"></p>
        </b-modal>
      </div>
      <!-- Modal LGPD -->

      <b-row>
        <b-col md="4">
          <b-btn
            variant="info"
            :disabled="documento == '' || currentPage <= 1"
            @click="currentPage--"
            class="mr-2"
          >
            <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
          </b-btn>
          {{ currentPage }} / {{ pageCount }}
          <b-btn
            class="ml-2"
            variant="info"
            :disabled="documento == '' || currentPage >= pageCount"
            @click="currentPage++"
          >
            <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
          </b-btn>

          <b-btn class="ml-4" variant="warning" @click="removeCurriculo()">
            Remover
          </b-btn>

          <b-form-group
            label="Envie seu currículo em formato PDF"
            label-for="input-1"
          >
            <b-form-file
              id="curriculoAnexo"
              ref="cvInput"
              type="file"
              name="curriculoAnexo"
              accept=".pdf"
              placeholder="Selecione um arquivo em formato pdf (Contendo o seu Currículo)"
              @change="uploadCurriculo"
            ></b-form-file>
          </b-form-group>
        </b-col>

        <b-col md="8">
          <pdf
            :src="documento"
            :page="this.currentPage"
            style="width: 90%"
            class="spanWrapper"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
          ></pdf>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { sharedService } from "../../services";
import SimpleVueValidation from "simple-vue-validator";
import pdf from "vue-pdf";

const Validator = SimpleVueValidation.Validator;

export default {
  components: { pdf },
  data() {
    return {
      documento: "",
      currentPage: 1,
      pageCount: 0,
      status: false,
    };
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    empresa: function () {
      return this.$store.getters.getEmpresa;
    },
  },
  validators: {
    status: function (value) {
      return Validator.value(value).required();
    },
  },
  methods: {
    async removeCurriculo() {
      let self = this;

      // console.log(self.$refs.cvInput.value);
      self.$refs.cvInput.reset();
      self.user.curriculo = "";
      self.documento = "";
      self.currentPage = 1;
    },
    async uploadCurriculo() {
      this.documento = "";
      this.numPages = undefined;
      let self = this;
      await sharedService
        .sendFiles(
          "Candidato/anexo",
          // eslint-disable-next-line
          curriculoAnexo.files[0],
          this.$store.getters.getApiKey
        )
        .then(function (obj) {
          obj.text().then(function (text) {
            if (obj.status === 200) {
              let curriculo = JSON.parse(text);
              self.user.curriculo = curriculo;
              self.documento = pdf.createLoadingTask(curriculo.nome);
              self.currentPage = 1;
            }
          });
        });
    },
  },
  beforeMount() {
    if (
      this.user.curriculo.nome !== undefined &&
      this.user.curriculo.nome.length > 0
    ) {
      this.documento = pdf.createLoadingTask(this.user.curriculo.nome);
      this.documento.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    }
  },
};
</script>

<style scoped>
.message {
  color: #f66;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  background: #fff;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  background: #3c3c3c;
  color: #17a2b8;
}

.custom-row-display {
  min-height: 40vh;
}

.custom-right-row {
  min-width: 55%;
  max-width: 55%;
}

.custom-left-row {
  min-width: 43%;
  max-width: 43%;
}

@media only screen and (max-width: 576px) {
  .justify-content-between {
    flex-direction: column;
    align-items: center;
  }

  .custom-left-row {
    min-width: 100%;
  }

  .custom-right-row {
    min-width: 100%;
    max-width: 100%;
    width: 100%;
    margin-top: 1.4rem;
  }

  .spanWrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>
